<div class="row checkbox-list">
    <div class="col-sm-12">        
        <ul>
            <li *ngFor="let row of dataSource" class="{{columnClass}}">               
                <label class="checkbox-inline custom-checkbox nowrap">
                    <nb-checkbox id="requireauthentication" name="requireauthentication" id="{{row.key}}" [(checked)]="row.checked" [disabled]="row.disabled" (change)="change($event, row)">{{row.caption}}</nb-checkbox>
                </label>
            </li>
        </ul>
    </div>
</div>